@if (options.control) {
<div class="recaptcha-wrapper" [id]="id" data-expired-callback="expiredCallback"></div>
} @else {
Form Control Is Not Defined
}
@if (options.isShowErrors) {
<span class="text-red-500 block" *ngIf="options.control?.errors?.['required']" translate="This field is required">
</span>
}